'use strict'

import angular from 'angular'

import buySheetInfoComponentHtmlUrl from './buySheetInfo.component.html'

angular.module('buySheet.components', []).component('buySheetInfo', {
    templateUrl: buySheetInfoComponentHtmlUrl,
    bindings: {
        info: '<'
    },
    controllerAs: 'vm'
})